// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * Shared register workspace for pages rendered through DashboardLayout.
 * DashboardLayout contributes 24px horizontal and 8px vertical padding, so
 * these negative margins expose the same full content canvas used by the
 * Invoice and Quotation register shells before applying responsive padding.
 */
.app-register-page-content {
  width: auto;
  min-width: 0;
  min-height: calc(100vh - 64px);
  margin: -8px -24px 0;
  padding: 32px;
  box-sizing: border-box;
  background: var(--bg-primary, #f4f7f7);
}

@media (max-width: 1024px) {
  .app-register-page-content {
    padding: 24px;
  }
}

@media (max-width: 767px) {
  .app-register-page-content {
    padding: 16px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/register-page-layout.css"],"names":[],"mappings":"AAAA;;;;;EAKE;AACF;EACE,WAAW;EACX,YAAY;EACZ,8BAA8B;EAC9B,oBAAoB;EACpB,aAAa;EACb,sBAAsB;EACtB,sCAAsC;AACxC;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,aAAa;EACf;AACF","sourcesContent":["/*\n * Shared register workspace for pages rendered through DashboardLayout.\n * DashboardLayout contributes 24px horizontal and 8px vertical padding, so\n * these negative margins expose the same full content canvas used by the\n * Invoice and Quotation register shells before applying responsive padding.\n */\n.app-register-page-content {\n  width: auto;\n  min-width: 0;\n  min-height: calc(100vh - 64px);\n  margin: -8px -24px 0;\n  padding: 32px;\n  box-sizing: border-box;\n  background: var(--bg-primary, #f4f7f7);\n}\n\n@media (max-width: 1024px) {\n  .app-register-page-content {\n    padding: 24px;\n  }\n}\n\n@media (max-width: 767px) {\n  .app-register-page-content {\n    padding: 16px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
